import React from "react";
import { Link, NavLink } from "react-router-dom";

function PdfLink({ href, children }) {
  return (
    <a className="dropdown-item" href={href} target="_blank" rel="noreferrer">
      {children}
    </a>
  );
}

export default function Header() {
  return (
    <>
      {/* Top banner */}
      <div className="top-banner-wrap">
        <img className="logo" src="/ik.png" alt="Logo" />
        <img className="banner-img" src="/School name.jpg" alt="Shri Ghanamatheshwar College of Education (B.Ed.)" />
      </div>

      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
        <div className="container-fluid">
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <NavLink className="nav-link" to="/">
                  Home
                </NavLink>
              </li>

              {/* About Us */}
              <li className="nav-item dropdown">
                <button className="nav-link dropdown-toggle btn btn-link" type="button" data-bs-toggle="dropdown">
                  About Us
                </button>
                <ul className="dropdown-menu">
                  <li>
                    <Link className="dropdown-item" to="/why_sgmtlkbed">
                      Why Ghanamatheshwar College of Education (B.Ed.)
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/history">
                      History
                    </Link>
                  </li>
                  <li><hr className="dropdown-divider" /></li>
                  <li>
                    <Link className="dropdown-item" to="/trustees">
                      Trustees&Advisory Commitee
                    </Link>
                  </li>
                  <li><hr className="dropdown-divider" /></li>
                  <li>
                    <Link className="dropdown-item" to="/vision_mission">
                      Vision,Mission&Objectives
                    </Link>
                  </li>
                  <li><hr className="dropdown-divider" /></li>
                  <li>
                    <Link className="dropdown-item" to="/principal">
                      About Principal
                    </Link>
                  </li>
                </ul>
              </li>

              {/* Resources */}
              <li className="nav-item dropdown">
                <button className="nav-link dropdown-toggle btn btn-link" type="button" data-bs-toggle="dropdown">
                  Resources
                </button>
                <ul className="dropdown-menu">
                  <li>
                    <Link className="dropdown-item" to="/infrastructure">
                      Facilities & Infrastructure
                    </Link>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/Library Facilities.pdf" target="_blank" rel="noreferrer">
                      Library
                    </a>
                  </li>
                  <li><hr className="dropdown-divider" /></li>
                  <li><Link className="dropdown-item" to="/laboratory">Laboratory</Link></li>
                  <li><hr className="dropdown-divider" /></li>
                  <li><Link className="dropdown-item" to="/class-rooms">Class Rooms</Link></li>
                  <li><hr className="dropdown-divider" /></li>
                  <li><Link className="dropdown-item" to="/comp-lab">Comp.Laboratory</Link></li>
                  <li><hr className="dropdown-divider" /></li>
                  <li><Link className="dropdown-item" to="/psychology">Psychology Resource Centre</Link></li>
                  <li><hr className="dropdown-divider" /></li>
                  <li><Link className="dropdown-item" to="/science-resource">Science Resource Centre</Link></li>
                  <li><hr className="dropdown-divider" /></li>
                  <li><Link className="dropdown-item" to="/social-science">Social Science Resource Centre</Link></li>
                  <li><hr className="dropdown-divider" /></li>
                  <li><Link className="dropdown-item" to="/art-craft">Art&Craft Resource Centre/Work Experience Room</Link></li>
                  <li><hr className="dropdown-divider" /></li>
                  <li><Link className="dropdown-item" to="/sports">Sports Facilities</Link></li>
                  <li><hr className="dropdown-divider" /></li>
                  <li><Link className="dropdown-item" to="/hostels">Hostels</Link></li>
                  <li><hr className="dropdown-divider" /></li>
                  <li><Link className="dropdown-item" to="/new-facilities">Newly Added Facilities</Link></li>
                </ul>
              </li>

              {/* Faculty */}
              <li className="nav-item dropdown">
                <button className="nav-link dropdown-toggle btn btn-link" type="button" data-bs-toggle="dropdown">
                  Faculty
                </button>
                <ul className="dropdown-menu">
                  <li><Link className="dropdown-item" to="/faculty/teaching">Teaching</Link></li>
                  <li><hr className="dropdown-divider" /></li>
                  <li><Link className="dropdown-item" to="/faculty/non-teaching">Non-Teaching</Link></li>
                </ul>
              </li>

              {/* Mandatory Disclosures */}
              <li className="nav-item dropdown">
                <button className="nav-link dropdown-toggle btn btn-link" type="button" data-bs-toggle="dropdown">
                  Mandatory Disclosures
                </button>
                <ul className="dropdown-menu">
                  <li><Link className="dropdown-item" to="/mandatory/ncte">NCTE Order</Link></li>
                  <li><hr className="dropdown-divider" /></li>
                  <li><Link className="dropdown-item" to="/mandatory/state">State Governament Order</Link></li>
                  <li><hr className="dropdown-divider" /></li>
                  <li><Link className="dropdown-item" to="/mandatory/university">University Notification</Link></li>
                  <li><hr className="dropdown-divider" /></li>
                  <li><Link className="dropdown-item" to="/mandatory/aishe">AISHE</Link></li>
                  <li><hr className="dropdown-divider" /></li>
                  <li><Link className="dropdown-item" to="/mandatory/audit">Audit Report</Link></li>
                  <li><PdfLink href="/Balance sheet, Income and expenditure.pdf">Balance Sheet</PdfLink></li>
                  <li><hr className="dropdown-divider" /></li>
                  <li><Link className="dropdown-item" to="/science-resource">Science Resource Centre</Link></li>
                </ul>
              </li>

              {/* Admission */}
              <li className="nav-item dropdown">
                <button className="nav-link dropdown-toggle btn btn-link" type="button" data-bs-toggle="dropdown">
                  Admission
                </button>
                <ul className="dropdown-menu">
                  <li><Link className="dropdown-item" to="/admission">Admission Procedure</Link></li>
                  <li><hr className="dropdown-divider" /></li>
                  <li><Link className="dropdown-item" to="/admission/fees">Fees</Link></li>
                  <li><hr className="dropdown-divider" /></li>
                  <li><Link className="dropdown-item" to="/admission/students">Students</Link></li>
                </ul>
              </li>

              {/* Course Outline */}
              <li className="nav-item dropdown">
                <button className="nav-link dropdown-toggle btn btn-link" type="button" data-bs-toggle="dropdown">
                  Course Outline
                </button>
                <ul className="dropdown-menu">
                  <li><Link className="dropdown-item" to="/course">About Course</Link></li>
                  <li><hr className="dropdown-divider" /></li>
                  <li><Link className="dropdown-item" to="/course/semester-outline">Semester Wise Course Outline</Link></li>
                </ul>
              </li>

              <li className="nav-item">
                <NavLink className="nav-link" to="/gallery">
                  Gallery
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/events">
                  Events
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/contact1">
                  Contact Us
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}
